import { useTranslation } from 'react-i18next';
import { Upload, Image as ImageIcon, Heart } from 'lucide-react';

const PhotoUpload = () => {
  const { t } = useTranslation();

  // Your live File Request link:
  const fileRequestUrl = "https://www.dropbox.com/request/7evvgzdqyKOi5gy8PSM6";

  // After the wedding, put your read-only shared folder link here (or leave empty to hide the button):
  const galleryUrl = ""; // "https://www.dropbox.com/scl/fo/6kgbpl3d78bihblfb523e/AJb0BGQImgoN9d-Y1Zh-rO0?rlkey=l146u4hk2dvbt9a1tlls0ddj2&st=yokbx6f6&dl=0"
  const showGalleryButton = true; // Set to false to completely hide the button

  return (
    <section className="py-20 bg-gradient-to-b from-amber-50 to-stone-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            {t('shareMemories')}
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto">
            {t('shareMemoriesDesc')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Upload Card */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-gray-200">
            <div className="bg-gray-900 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <Upload className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-center mb-4 text-gray-900">
              {t('uploadPhotos')}
            </h3>
            <p className="text-center text-gray-600 mb-6">
              {t('uploadPhotosDesc')}
            </p>

            <a
              href={fileRequestUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-gray-900 text-white font-semibold py-4 px-6 rounded-xl hover:bg-black transition text-center"
              aria-label={t('uploadNow')}
            >
              📸 {t('uploadNow')}
            </a>

            {/* Gallery button - disabled until after wedding */}
            {showGalleryButton && (
              galleryUrl ? (
                <a
                  href={galleryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 block w-full bg-gray-700 text-white font-semibold py-3 px-6 rounded-xl hover:bg-gray-800 transition text-center"
                  aria-label={t('viewGallery') || 'View & Download Photos'}
                >
                  🖼️ {t('viewGallery') || 'View & Download Photos'}
                </a>
              ) : (
                <div className="mt-3 block w-full bg-gray-400 text-gray-600 font-semibold py-3 px-6 rounded-xl text-center cursor-not-allowed opacity-70">
                  🖼️ {t('galleryComingSoon') || 'Gallery Coming Soon'}
                </div>
              )
            )}

            <p className="mt-4 text-center text-sm text-gray-500">
              {t('noLoginNeeded') || 'No app or login needed.'}
            </p>
          </div>

          {/* Info Cards */}
          <div className="space-y-4">
            <div className="bg-white rounded-xl shadow-md p-6 flex items-start gap-4 border border-gray-200">
              <div className="bg-stone-100 p-3 rounded-lg flex-shrink-0">
                <ImageIcon className="w-6 h-6 text-gray-800" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">{t('allFormats')}</h4>
                <p className="text-sm text-gray-600">{t('allFormatsDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 flex items-start gap-4 border border-gray-200">
              <div className="bg-stone-100 p-3 rounded-lg flex-shrink-0">
                <Heart className="w-6 h-6 text-gray-800" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">{t('sharedAlbum')}</h4>
                <p className="text-sm text-gray-600">{t('sharedAlbumDesc')}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 flex items-start gap-4 border border-gray-200">
              <div className="bg-stone-100 p-3 rounded-lg flex-shrink-0">
                <Upload className="w-6 h-6 text-gray-800" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">{t('easyUpload')}</h4>
                <p className="text-sm text-gray-600">{t('easyUploadDesc')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Optional tip text */}
        <div className="mt-10 text-center text-gray-500 text-sm">
          {t('uploadTip') || 'Tip: Use Wi-Fi for large videos; photos upload fastest from your phone’s browser.'}
        </div>
      </div>
    </section>
  );
};

export default PhotoUpload;
